import React, { useContext, useEffect } from 'react'
import ReactPaginate from 'react-paginate'
import { toast, ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom'
import { deleteStaff } from '../../../action';
import { GlobalState } from '../../../GlobalState';
import { TabTitle } from '../../../util/titleChanger'
import Loading from '../../../util/Loading';
import { api } from '../../../util/urlConfig';

export default function StaffDashboard() {
    TabTitle("Staff Dashboard");
    const state = useContext(GlobalState);
    const [staffs] = state.staffAPI.staffs;
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    //Local states
    const [rowPerPage] = state.staffAPI.rowPerPage;
    const [pageNumber, setPageNumber] = state.staffAPI.pageNumber;
    const [totalPages] = state.staffAPI.totalPages;
    const [setSearch] = state.staffAPI.search;
    const [callback, setCallback] = state.staffAPI.callback;

    useEffect(() => { }, [rowPerPage, staffs, pageNumber])

    const pageNumberHandler = (data) => {
        let newPageNumber = data.selected + 1;
        setPageNumber(newPageNumber)
    }

    const searchHandler = (e) => {
        e.preventDefault();
        setPageNumber(1);
        setSearch(e.target.value ? e.target.value : "");
    }

    const deleteStaffHandler = (id) => {
        deleteStaff(id, signInUser.id, res => {
            if (res.status === 200) {
                toast.success(res.data);
                setCallback(!callback)
            } else {
                toast.error(res.data);
                setCallback(!callback)
            }
        })
    }
    return (
        <div className='form-container'>
            <div className="table">
                <div className="table_header">
                    <p>Staff Details</p>
                    <div>
                        <input
                            type="text"
                            name="search"
                            id="search"
                            placeholder='Search staff here...'
                            onChange={(e) => searchHandler(e)}
                        />
                        <Link to="/staff-form"><button className="add_new">+ Add New</button></Link>
                    </div>
                </div>

                {
                    staffs.count === 0 ? <div className="loading-page-container"><Loading /></div>
                        : <div className="table_section">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Avatar</th>
                                        <th>Staff Code</th>
                                        <th>Full Name</th>
                                        <th>NIC</th>
                                        <th>Contact No</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        staffs.count > 0 ? staffs.data.map(staff => (
                                            <tr key={staff.id}>
                                                <td>
                                                    <img src={staff.upload_image ? api + "/" + staff.upload_image.image_url : '/img/dummy_avatar.png'} alt="avatar" />
                                                </td>
                                                <td>{staff.staff_code}</td>
                                                <td>{staff.first_name + " " + staff.last_name}</td>
                                                <td>{staff.nic}</td>
                                                <td>{staff.contact_no}</td>
                                                <td>
                                                    <Link to={`/staff-form/${staff.id}`}><button><i className="uil uil-edit"></i></button></Link>
                                                    <Link to={`/staff-view/${staff.id}`}><button><i className="uil uil-eye"></i></button></Link>
                                                    <button onClick={() => deleteStaffHandler(staff.id)}><i className="uil uil-trash-alt"></i></button>
                                                </td>
                                            </tr>
                                        ))
                                            : <tr>
                                                <td colSpan="6">Can not found any staffs.</td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                }

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={pageNumberHandler}
                    marginPagesDisplayed={2}
                    pageCount={totalPages}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageLinkClassName='page-num'
                    previousLinkClassName='page-num'
                    nextLinkClassName='page-num'
                    activeLinkClassName='active-num'
                />
            </div>
            <ToastContainer />
        </div>
    )
}